export default __webpack_public_path__ + "static/media/liel-kaizer.7236ef29.png";